export default __webpack_public_path__ + "static/media/img (2).b0f850dd.jpg";